import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const TEMPLATE_COLLECTION_QUERY = gql`
  query TemplateCollectionQuery($id: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    templateCollection(id: $id) {
      ... on TemplateCollectionNode {
        ...TemplateCollectionGraphQL
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${getFragmentWrapper('TemplateCollection').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
